import { Box, Stack, Typography } from "@mui/material";

import type { ResponsiveDetailSection } from "../../../components/common/ResponsiveDetailSections";
import { currencyFormatter, formatChannelLabel /*,  formatSourceLabel */ } from "../../../lib/presentation";
import type { DataQualityRow, OrderRow } from "../../../types";

interface BuildClientDetailsArgs {
    hiddenIssueCount: number;
    hiddenOrderCount: number;
    orders: OrderRow[];
    visibleIssues: DataQualityRow[];
    visibleOrders: OrderRow[];
}

export function buildClientDetailSections({
                                              // hiddenIssueCount,
                                              hiddenOrderCount,
                                              orders,
                                              // visibleIssues,
                                              visibleOrders,
                                          }: BuildClientDetailsArgs): ResponsiveDetailSection[] {
    return [
        // {
        //     align: "center",
        //     id: "issues",
        //     title: `Рискове и валидация (${visibleIssues.length + hiddenIssueCount})`,
        //     summary: visibleIssues.length > 0
        //         ? `${visibleIssues[0].issue}${visibleIssues.length + hiddenIssueCount > 1 ? ` и още ${visibleIssues.length + hiddenIssueCount - 1}` : ""}`
        //         : "Няма отворени грешки за избрания профил.",
        //     content: (
        //         <Stack spacing={1.25} sx={{ alignItems: "center" }}>
        //             {visibleIssues.length > 0 ? (
        //                 visibleIssues.map((issue) => (
        //                     <Box key={`${issue.entity}-${issue.issue}`} sx={{ textAlign: "center" }}>
        //                         <Typography sx={{ fontWeight: 700 }}>
        //                             {issue.issue}
        //                         </Typography>
        //                         <Typography variant="body2" color="text.secondary">
        //                             {issue.displayEntity ?? issue.entity}
        //                             {issue.source ? ` · ${formatSourceLabel(issue.source)}` : ""}
        //                         </Typography>
        //                     </Box>
        //                 ))
        //             ) : (
        //                 <Typography variant="body2" color="text.secondary">
        //                     Няма отворени грешки за избрания профил.
        //                 </Typography>
        //             )}
        //
        //             {hiddenIssueCount > 0 && (
        //                 <Typography variant="body2" color="text.secondary">
        //                     Още {hiddenIssueCount} сигнала са налични в пълния списък.
        //                 </Typography>
        //             )}
        //         </Stack>
        //     ),
        // },

        {
            align: "center",
            id: "orders",
            title: `Свързани поръчки (${orders.length})`,
            summary: orders.length > 0
                ? `${orders[0].orderNumber}${orders.length > 1 ? ` и още ${orders.length - 1}` : ""}`
                : "Още няма вързани поръчки в текущия поток.",
            content: (
                <Stack spacing={1.25} sx={{ alignItems: "center" }}>
                    {orders.length > 0 ? (
                        <Box sx={{
                            display: "flex",
                            gap: 2,
                            justifyContent: "center",
                            flexWrap: "wrap",
                            width: "100%"
                        }}>
                            {visibleOrders.map((order) => (
                                <Box
                                    key={order.orderNumber}
                                    sx={{
                                        textAlign: "center",
                                        flex: "0 0 auto",
                                        minWidth: "180px",
                                        p: 1.5,
                                        border: "1px solid",
                                        borderColor: "divider",
                                        borderRadius: 1,
                                        bgcolor: "background.paper"
                                    }}
                                >
                                    <Typography sx={{ fontWeight: 700 }}>
                                        {order.orderNumber}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        {formatChannelLabel(order.channel)} · {order.status} · {currencyFormatter.format(order.value)}
                                    </Typography>
                                </Box>
                            ))}
                        </Box>
                    ) : (
                        <Typography variant="body2" color="text.secondary">
                            Още няма вързани поръчки в текущия поток.
                        </Typography>
                    )}

                    {hiddenOrderCount > 0 && (
                        <Typography variant="body2" color="text.secondary">
                            Още {hiddenOrderCount} поръчки са налични в пълния списък.
                        </Typography>
                    )}
                </Stack>
            ),
        },
    ];
}